// extracted by mini-css-extract-plugin
module.exports = {"r1sa6ui2":"r1sa6ui2","i16qv8bl":"i16qv8bl"};